import { TEAMS, getTeamMeta, formatScoreAbbreviated } from './transformersCompetition';

const RECAP_HEALED_LIST_CAP = 4;

// Builds the fixed, pre-approved Discord recap text from the raw recap data - deterministic on
// purpose (no free-form generation) so the format never drifts week to week. Admin copies this
// straight into Discord and edits by hand if they want to add anything.
export function formatRecapText(recap) {
  const lines = [];
  lines.push(`WEEK ${recap.roundNumber} RECAP`);
  lines.push('');

  if (recap.winningTeam) {
    lines.push(`🏆 ${recap.winningTeam.teamName} win the week!`);
    if (recap.winningTeam.healPercentApplied > 0) {
      lines.push(`Every ${recap.winningTeam.teamName.replace(/s$/, '')} still in contention gets a +${recap.winningTeam.healPercentApplied}% Battery recharge.`);
    }
    lines.push('');
    // Surplus changed units at week 10: percent over target before, raw points after. A week
    // has to print the units it was settled in, and say which, because the line underneath is
    // a raw score difference and the two used to sit together unlabelled.
    const surplusIsRaw = recap.surplusFormulaVersion === 2;
    recap.teamStandings.forEach(t => {
      const value = surplusIsRaw
        ? `+${formatScoreAbbreviated(t.energonTotal)}`
        : `+${Math.round(t.energonTotal * 10) / 10}%`;
      lines.push(`${t.rank}. ${t.teamName}: ${value} Surplus`);
    });
    lines.push('');
  }

  if (recap.standoutBiggestBeat || recap.standoutHighestScore) {
    lines.push('⭐ Standout Performances');
    if (recap.standoutBiggestBeat) {
      const b = recap.standoutBiggestBeat;
      lines.push(`- Biggest beat: ${b.name}, +${formatScoreAbbreviated(b.beat)} over target (${getTeamMeta(b.team).name})`);
    }
    if (recap.standoutHighestScore) {
      const h = recap.standoutHighestScore;
      lines.push(`- Highest score: ${h.name}, ${formatScoreAbbreviated(h.score)} (${getTeamMeta(h.team).name})`);
    }
    lines.push('');
  }

  if (recap.healed.length > 0) {
    const teamName = recap.winningTeam ? recap.winningTeam.teamName : '';
    lines.push(`🔋 Healed this week (${teamName}, still in contention)`);
    const names = recap.healed.map(p => p.name);
    const shown = names.slice(0, RECAP_HEALED_LIST_CAP);
    const remaining = names.length - shown.length;
    lines.push(shown.join(', ') + (remaining > 0 ? ` ... (+${remaining} more)` : ''));
    lines.push('');
  }

  if (recap.newlyLocked.length > 0) {
    lines.push('⚠️ Fell into Stasis Lock this week');
    // One line per team, in the fixed team order, skipping teams that lost nobody.
    TEAMS.forEach(team => {
      const names = recap.newlyLocked.filter(p => p.team === team.id).map(p => p.name);
      if (names.length > 0) {
        lines.push(`${names.length} ${team.name}: ${names.join(', ')}`);
      }
    });
    lines.push('');
  }

  if (recap.grandChampion) {
    lines.push(`👑 GRAND CHAMPION: ${recap.grandChampion}! The season is complete.`);
  } else if (recap.tieBreakNote) {
    lines.push(`⚠️ The season has ended in a tie that needs manual resolution: ${recap.tieBreakNote}`);
  } else if (recap.nextRoundNumber) {
    lines.push(`Season status: Week ${recap.nextRoundNumber} is now open. ${recap.remainingInContention} players remain in contention.`);
  }

  return lines.join('\n').trim();
}
